import React, {useEffect} from 'react'
import {
  useParams
} from 'react-router-dom'
import AlertsPage from '../../../alerts_page/alerts-page'

const CustomerAlertsPage = ({

}) => {

  const params = useParams()
  return (
    <AlertsPage
      onTabCustomerID={params.id}
    />
  )
}

export default CustomerAlertsPage
